import React from "react";
import FormDocumentPicturePreview from "../../../../../../components/common/PL/PicturePreview/FormDocumentPicturePreview";
import "./BicycleContentForm.css";

const BicycleContentForm = () => {
  return (
    <div className="bicycleContentFormContainer">
      <FormDocumentPicturePreview
        name="accessVehicleBikePhoto"
        label="Tomar foto de la bicicleta"
        previewHeight={400}
        allowClear
        allowImageViewer
      />
    </div>
  );
};

export default BicycleContentForm;
